import React, { useEffect, useState } from "react";

import { Card, CardBody, CardHeader, Col, Button } from "reactstrap";
import { Fade } from "react-reveal";
import './Helper.css'; 

const useIsMobile = () => {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const mql = window.matchMedia('(max-width: 767px)');
		const onChange = () => setIsMobile(mql.matches);
		onChange();

		if (typeof mql.addEventListener === 'function') {
			mql.addEventListener('change', onChange);
			return () => mql.removeEventListener('change', onChange);
		}

		mql.addListener(onChange);
		return () => mql.removeListener(onChange);
	}, []);

	return isMobile;
};

const GamesCard = ({ data }) => {
	const isMobile = useIsMobile();

	const card = (
		<Card className="shadow-lg--hover shadow mt-4">
			<CardHeader className="p-0 text-center">
				<img src={data.img} className="game-img"/>
			</CardHeader>
			<CardBody>
				<div className="d-flex px-3">
					<div className="pl-4">
						<h3>{data.name}</h3>
						<p className="description mt-3">{data.desc}</p>
						{data.link ? (
							<Button
								className="btn-icon"
								color="success"
								href={data.link}
								target="_blank"
							>
								<span className="btn-inner--icon">
									<i className="fa fa-play mr-2" />
								</span>
								<span className="nav-link-inner--text ml-1">
									Play
								</span>
							</Button>
						) : null}
					</div>
				</div>
			</CardBody>
		</Card>
	);

	return (
		<Col lg="6">
			{isMobile ? card : <Fade bottom duration={1000} distance="40px">{card}</Fade>}
		</Col>
	);
};

export default GamesCard;
